import { Component, forwardRef, OnInit, OnDestroy } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { Subscription } from 'rxjs';
import { AddressFormValues } from 'src/app/model';

@Component({
  selector: 'app-address-form',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AddressFormComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AddressFormComponent),
      multi: true
    }
  ]
})
export class AddressFormComponent implements ControlValueAccessor, OnDestroy, OnInit {

  form: FormGroup;
  private _subscriptions: Subscription[] = [];
  private _valueChangesSubscription: Subscription;


  constructor(
    private _fb: FormBuilder,
  ) {
    this.form = this._fb.group({
      lineOne: [''],
      lineTwo: [''],
      city: [''],
      state: [''],
      postalCode: [''],
      country: ['']
    });

    this._subscriptions.push(
      this._valueChangesSubscription = this.form.valueChanges.subscribe(value => {
        this.onChange(value);
        this.onTouched();
      })
    );
  }


  ngOnInit(): void { }

  get value(): AddressFormValues {
    return this.form.value;
  }

  get addressFormValues() {
    return this.form.controls;
  }

  set value(value: AddressFormValues) {
    this.form.setValue(value);
    this.onChange(value);
    this.onTouched();
  }

  ngOnDestroy() {
    this._subscriptions.forEach(s => s.unsubscribe());
    this._valueChangesSubscription?.unsubscribe();

  }

  onChange: any = () => { };
  onTouched: any = () => { };

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  writeValue(value: AddressFormValues | null) {
    if (value) {
      this.value = value;
    }
    if (value === null) {
      this.form.reset();
    }
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  // communicate the inner form validation to the parent form
  validate(_: FormControl) {
    return this.form.valid ? null : { name: { valid: false } };
  }
}
